import { Chip } from '@mui/material';

function TagItem({ label }) {
  return (
    <Chip
      label={label}
      sx={{
        borderRadius: 0,
        backgroundColor: 'action.hover',
        color: 'action.selected',
        fontWeight: 400,
        fontSize: 14
      }}
    />
  )
};

export default TagItem;
